// API Configuration
export const API_CONFIG = {
  // Set to false to use real backend API, true to use mock API
  USE_MOCK_API: false, // Change to false when backend is ready
  
  // Backend API endpoints - try in order
  LOCAL_BACKEND_URLS: [
    'https://localhost:7214/api', // C# backend HTTPS (default)
    'http://localhost:7214/api',   // C# backend HTTP (fallback)
    'http://localhost:3000/api',   // Alternative local backend
    'http://localhost:5000/api',   // Alternative local backend
  ],
  PRODUCTION_BACKEND_URL: 'https://learn-to-mend.onrender.com/api',
  // Backend API endpoints
  // In development use the local API; in production use the deployed API.
  BACKEND_URL: process.env.NODE_ENV === 'production'
    ? 'https://learn-to-mend.onrender.com/api'
    : 'https://localhost:7214/api',

  // Developer convenience: Swagger UI for the local API
  SWAGGER_URL: 'https://localhost:7214/swagger/index.html',
  
  // Mock API settings
  MOCK_DELAY: 1000, // Delay for mock API responses
};

// Helper function to check if mock API should be used
export const shouldUseMockAPI = () => {
  return API_CONFIG.USE_MOCK_API;
};

// Helper function to get API base URL with fallback
export const getApiBaseUrl = () => {
  // In development, use first local URL (can be overridden by env var)
  if (process.env.NODE_ENV === 'development') {
    const useLocal = process.env.REACT_APP_USE_LOCAL_API !== 'false';
    if (useLocal) {
      return API_CONFIG.LOCAL_BACKEND_URLS[0];
    }
  }
  
  // Production always uses production backend
  return API_CONFIG.PRODUCTION_BACKEND_URL;
};

// Helper function to get all possible API URLs (for fallback logic)
export const getAllApiUrls = () => {
  if (process.env.NODE_ENV === 'development') {
    return [...API_CONFIG.LOCAL_BACKEND_URLS, API_CONFIG.PRODUCTION_BACKEND_URL];
  }
  return [API_CONFIG.PRODUCTION_BACKEND_URL];
};
